"use strict";

class SuperAgentViewController {

    constructor($scope, $window, $timeout, $parse, SSHttpService, SSUtilService, SSConfigService, SSAlertService, SSConfirmationService, OTPService, SSUserService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.$parse = $parse;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.USER_STATUS_ACTIVE = SHOWSUITE.USER_STATUS_ACTIVE;   //  = 1;
        self.USER_STATUS_PENDING = SHOWSUITE.USER_STATUS_PENDING;  //  = 0;  Or Null
        self.USER_STATUS_INACTIVE = SHOWSUITE.USER_STATUS_INACTIVE; //  = 2;  Or removed

        self.PROJECT_BROKER_TYPE_TEAMLEAD = SHOWSUITE.PROJECT_BROKER_TYPE_TEAMLEAD;
        self.PROJECT_BROKER_TYPE_ASSISTANT_TEAMLEAD = SHOWSUITE.PROJECT_BROKER_TYPE_ASSISTANT_TEAMLEAD;
        self.PROJECT_BROKER_TYPE_BROKER = SHOWSUITE.PROJECT_BROKER_TYPE_BROKER;
        self.PROJECT_BROKER_TYPE_TAGGER = SHOWSUITE.PROJECT_BROKER_TYPE_TAGGER;

        self.roles = [
            {
                id: self.PROJECT_BROKER_TYPE_TEAMLEAD,
                name: 'Team Lead'
            },
            {
                id: self.PROJECT_BROKER_TYPE_ASSISTANT_TEAMLEAD,
                name: 'Assistant Team Lead'
            },
            {
                id: self.PROJECT_BROKER_TYPE_BROKER,
                name: 'Broker'
            },
            {
                id: self.PROJECT_BROKER_TYPE_TAGGER,
                name: 'Tagger'
            },
        ];

        self.user_status = {};

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.rowLimit = 10;
        self.apiOffset = 0;
        self.apiLimit = self.rowLimit;
        self.is_support_staff = true;

        self.brokers = [];

        self.current = 1;
        self.jump_to_page = 1;
        self.pageNo = 1;

        self.setUserStatus();
        self.getAgencies();
        self.getProperties();
        self.getAgencyBrokers(1);

        self.pageChanged = function (newPage) {
            self.getAgencyBrokers(newPage);
        };
    }

    viewBroker(broker) {
        this.$window.location.href = [this.BASE_URL, broker.user_id].join("/");
    }

    getAgencyBrokers(page) {
        const self = this;

        if (page) {
            self.current = page;
        }

        self.apiOffset = (page * self.apiLimit) - self.apiLimit;

        let url = 'sec/super/brokers';
        let params = {
            offset: self.apiOffset,
            limit: self.apiLimit,
            include: 'users',
            send_total_count: true
        };

        if (self.selectedAgency) {
            params.agency_id = self.selectedAgency;
        }

        if (self.selectedProperty) {
            params.property_id = self.selectedProperty;
            params.role = self.selectedRole;
        }

        if (self.selectedCriteria) {
            params.criteria = self.selectedCriteria;
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.brokers = response.data.brokers;
            self.users = response.data.users;

            $.each(self.brokers, function (index, broker) {
                broker["support_staff"] = broker.is_support_staff ? 'Yes' : 'No';
                broker["user"] = self.getBrokerUser(broker.user_id);
                broker.user["name"] = broker.user.first_name + ' ' + broker.user.last_name;
                broker["agency"] = self.getBrokerAgency(broker.agency_id);

                if (broker.user) {
                    broker.user["status_name"] = self.getStatusName(broker.user.status);
                }
            });

            self.total_count = response.data.total_count;

            self.prepareBrokersPaginationData();
        });
    }

    getBrokerUser(id) {
        const self = this;
        if (self.users) {
            return self.users.find(x => x.id === id);
        }
    }

    getBrokerAgency(id) {
        const self = this;
        if (self.agencies) {
            return self.agencies.find(x => x.id === id);
        }
    }

    setUserStatus() {
        const self = this;

        self.user_status[SHOWSUITE.USER_STATUS_ACTIVE] = {StatusName: 'Active', StatusClass: 'text-success'};
        self.user_status[SHOWSUITE.USER_STATUS_PENDING] = {StatusName: 'Pending', StatusClass: 'text-warning'};
        self.user_status[SHOWSUITE.USER_STATUS_INACTIVE] = {StatusName: 'Inactive', StatusClass: ''};
    }

    getStatusName(status) {
        const self = this;

        try {
            if (status) {
                return self.user_status[status].StatusName;
            } else {
                return self.user_status[0].StatusName;
            }
        } catch (ex) {
            return '-';
        }
    }

    getStatusClass(status) {
        const self = this;

        try {
            if (status) {
                return self.user_status[status].StatusClass;
            } else {
                return self.user_status[0].StatusClass;
            }
        } catch (ex) {
            return '';
        }
    }

    updateRowLimit() {
        const self = this;

        self.apiOffset = 0;
        self.apiLimit = parseInt(self.rowLimit);
        self.getAgencyBrokers(1);
    }

    updateBroker(data) {
        const self = this;

        self.updateAgentParams = {};
        self.updateAgentErrors = {};

        if (data) {
            self.updateAgentParams = self.getAgentParams(data);
        }

        $('#updateAgentModal').modal('show');

    }

    getAgentParams(data) {
        const self = this;

        let updateAgentParams = {};

        try {
            updateAgentParams.id = data.user_id;
            updateAgentParams.broker_agency_id = data.agency_id;
            updateAgentParams.is_support_staff = data.is_support_staff ? true : null;
            updateAgentParams.is_tele_sale_staff = data.is_tele_sale_staff ? true : null;
            updateAgentParams.broker_about = data.about;
            updateAgentParams.broker_agency_id = data.agency_id ? data.agency_id : data.broker.agency_id;
            updateAgentParams.broker_reg_no = data.reg_no ? data.reg_no : '';
            updateAgentParams.broker_ext_no = data.ext_no ? data.ext_no : '';
            updateAgentParams.broker_nric = data.nric ? data.nric : '';
        } catch (ex) {
            console.log(ex);
        }

        return updateAgentParams;
    }

    getAgencies() {
        const self = this;

        self.agencies = [];
        let url = 'agencies';
        let params = {
            'format': 1
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.agencies) {
                self.agencies = response.data.agencies;
            }

        });
    }

    getProperties() {
        const self = this;

        self.properties = [];
        let url = 'properties/customized';

        loading(true);
        self.SSHttpService.getAPIRequest(url, {
            offset: 0,
            limit: 1000,
            property_selected_fields: 'id,name'
        }).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.properties) {
                self.properties = response.data.properties;
            }

        });
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }
        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');

            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }

                let value = self.$parse(model)(context);

                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }

            field.on("keyup change", function () {
                field.parent().removeClass("has-warning");
            });
            field.blur(function () {

                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));

                field.parent().removeClass("has-warning");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-warning");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }

            });
        });
    }

    setPageNoAndLoadPropertyBrokers(pageNo) {
        const self = this;

        if (pageNo) {
            if (pageNo == 'next') {
                pageNo = self.pageNo + 1;
            } else if (pageNo == 'previous') {
                pageNo = self.pageNo - 1;
            }

            if (pageNo > self.total_count) {
                pageNo = self.total_count;
            } else if (pageNo < 1) {
                pageNo = 1;
            }

            if (pageNo == self.pageNo) {
                return; // Ignore if no change
            }

            self.pageNo = pageNo;
        }

        self.apiOffset = (self.pageNo - 1) * self.apiLimit;

        self.getAgencyBrokers(self.pageNo);
    }

    prepareBrokersPaginationData() {
        const self = this;

        self.total_count = Math.ceil(self.total_count / self.apiLimit);

        self.brokerPagesArrayDisplay = [];
        self.brokerPagesArray = [];

        for (let i = 0; i < self.total_count; i++) {
            self.brokerPagesArray.push(i + 1);
        }

        for (let i = self.pageNo - 3; i <= self.pageNo; i++) {
            if (i <= 0)
                continue;
            self.brokerPagesArrayDisplay.push(i);
        }

        for (let j = self.pageNo + 1; j <= self.pageNo + 3; j++) {
            if (j > self.total_count)
                break;
            self.brokerPagesArrayDisplay.push(j);
        }

        if (self.total_count < self.pageNo) {
            self.pageNo = 1;
        }
    }

    clearFilters() {
        const self = this;
        self.selectedProperty = '';
        self.selectedRole = '';
        self.selectedAgency = '';
        self.selectedCriteria = '';
        self.getAgencyBrokers(1);
    }

    isValidBrokerInput() {
        const self = this;

        let isValid = true;

        if (!self.updateAgentParams.broker_agency_id) {
            self.updateAgentErrors.broker_agency_id = "Broker Agency is required";
            isValid = false;
        }

        if (!self.updateAgentParams.broker_reg_no) {
            self.updateAgentErrors.broker_reg_no = "CEA number is required";
            isValid = false;
        }

        return isValid;
    }

    _updateBroker() {
        const self = this;

        if (!self.isValidBrokerInput())
            return;

        let broker_id = self.updateAgentParams.id;

        let url = 'sec/super/brokers/' + broker_id;

        delete self.updateAgentParams.id;

        self.updateAgentParams.is_tele_sale_staff = self.updateAgentParams.is_tele_sale_staff ? 1 : 0;

        loading(true);
        self.SSHttpService.putAPIRequest(url, self.updateAgentParams).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (response.data) {
                let previousData = self.brokers.find(x => x.user_id == broker_id);
                angular.merge(previousData, response.data);
                previousData["support_staff"] = response.data.is_support_staff ? 'Yes' : 'No';
            }

        });
    }

    hideModals() {
        const self = this;

        if ($('#updateAgentModal').is(':visible')) $('#updateAgentModal').modal('hide');
    }
}

SuperAgentViewController.$inject = ["$scope", "$window", "$timeout", "$parse", "SSHttpService", "SSUtilService", "SSConfigService", "SSAlertService", "SSConfirmationService", "OTPService", "SSUserService"];
app.controller('SuperAgentViewController', SuperAgentViewController);

